import React, { Component } from "react";

import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon"

import MDInput from "components/MDInput";
import MDBox from "components/MDBox";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";

import MDTypography from "components/MDTypography";
import styles from "./index.module.css";

import { PATH, UPLOAD_PATH } from "../../constant";
import 'dayjs/locale/it';

import * as ajax from "helpers/ajax";
import dayjs from 'dayjs';
import Calendar from 'react-calendar'
import CalendarIcon from 'components/CalendarIcon'
import Tooltip from '@mui/material/Tooltip';
import { convertDate, getBusinessDatesCount, calculateFinalDate, toEuropeanDate } from "helpers/functions"

export class CommesseCalendar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            dateSelected: new Date()
        };
    }

    componentDidMount = () => {
        ajax.ajaxGetStrapi("commessas", this.loadCallback)
    }

    loadCallback = (response) => {

        let data = [];
        response.data.map((el) => {
            if (!data[el.data_inizio]) {
                data[el.data_inizio] = {
                    starting: [],
                    ending:[]
                }
            }

            let durata = el.durata;
            if (el.proroga) {durata+=el.proroga}
            
            // Usa calculateFinalDate per considerare sia giorni lavorativi che festivi
            const excludeFestiveDays = el.days_type === "Lavorativi";
            const endDateFormatted = calculateFinalDate(el.data_inizio, durata, excludeFestiveDays);
            // Converti da formato europeo (DD/MM/YYYY) a formato ISO (YYYY-MM-DD)
            if (endDateFormatted) {
                const [day, month, year] = endDateFormatted.split('/');
                el.end_date = `${year}-${month}-${day}`;
            } else {
                el.end_date = null;
            }

            data[el.data_inizio].starting.push(el.nome)
            if (!data[el.end_date]) {
                data[el.end_date] = {
                    starting: [],
                    ending: []
                }
            }
            data[el.end_date].ending.push(el.nome)
        })

        this.setState({ data: data })
    }

    convertDate = (date) => {
        var yyyy = date.getFullYear().toString();
        var mm = (date.getMonth() + 1).toString();
        var dd = date.getDate().toString();

        var mmChars = mm.split('');
        var ddChars = dd.split('');

        return yyyy + '-' + (mmChars[1] ? mm : "0" + mmChars[0]) + '-' + (ddChars[1] ? dd : "0" + ddChars[0]);
    }


    renderDate = (date) => {
        let returnValue = []


        if (this.state.data[date]) {
            if (this.state.data[date].starting.length > 0) {
                this.state.data[date].starting.map((el) => {
                    returnValue.push(<Tooltip key={date + el + "start"} title={"Inizio Commessa: "+el} ><div className={styles.startingDay} /></Tooltip>)
                })
            }
            if (this.state.data[date].ending.length > 0) {
                this.state.data[date].ending.map((el) => {
                    returnValue.push(<Tooltip key={date + el + "end"} title={"Fine Commessa: "+el} ><div className={styles.closingDay} /></Tooltip>)
                })
            }
        }


        return (
            <div className={styles.dayContainer}>{returnValue}</div>
        );
    }

    render() {

        return (
            <>
                <MDTypography variant={"h5"} textTransform={"uppercase"} mb={2} >Calendario Commesse <CalendarIcon onChange={(val) => this.setState({dateSelected:val})}/></MDTypography>
                <Calendar className={styles.calendar} tileContent={(date) => this.renderDate(this.convertDate(date.date))} onActiveStartDateChange={(val) => this.setState({ dateSelected: val.activeStartDate })} activeStartDate={new Date(this.state.dateSelected)} />
            </>
        )

    }
}

export default CommesseCalendar;


CommesseCalendar.defaultProps = {

}
